import { useState } from 'react'
import cn from 'classnames'

import Mirror from 'src/icons/mirror.webp'
import { ContentSteps } from 'src/lib/useStepFlow'
import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'
import { Button } from 'src/shared/ui/lib/button/Button'
import { TLang } from 'src/constants/langs'
import { texts } from './text-second-step'
import { textBtn } from './mock'
import cls from './styles.module.scss'

type TProps = {
    onNext: (step: ContentSteps) => void
    step: ContentSteps
    lang: TLang
}

export const SecondStep = ({ onNext, step, lang }: TProps) => {
    const { content } = useLocalizedText(lang, texts)
    const [goodBye, setGoodBye] = useState(false)

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    const handleClick = () => {
        setGoodBye(true)
        setTimeout(() => {
            onNext(step)
        }, 300)
    }

    return (
        <div
            className={cn(cls.root, {
                [cls.hello]: !goodBye,
                [cls.good_bye]: goodBye,
            })}
        >
            <div
                className={cls.mirror}
                style={{ backgroundImage: `url(${Mirror})` }}
            >
                <div className={cls.container}>{content}</div>
                <Button
                    value={getBtnTextByLang()}
                    mode="primary"
                    className={cls.button}
                    onClick={handleClick}
                />
            </div>
        </div>
    )
}
